module.exports = __webpack_public_path__ + "img/small_eye_redchart03.b8356d5f.jpg";